/**
 * module-16.js
 *
 * Javascript for Module#9
 *
 * @package Wordpress/imhof-digital
 * @since   5.6.0
 * @author  Imhof Digital <info@imhof-digital.de>
 */

jQuery( document ).ready( function( $ ) {
  // declare strict mode
  'use strict';

  if( $( '.module-16' ) ) {

    /**
     * idscript.module_16
     *
     * @since     5.6.0
     * @property  object      sliderContainer   The container of module 9 slider
     * @property  object      textContainer     The text container of module 9
     * @method    maxHeight()                   Checks the real height of the ul-elements
     * @method    adjustLists()                 Adjusts the lists to equal height
     * @method    init()                        Initiate the module 11 object
     */
    idscript.module_16 = {
      /**
       * @var   container The module container
       * @since 5.6.0
       */
      container: $( '.module-16.modulecontainer' ),

      /**
       * @var   tiles The tiles
       * @since 5.6.0
       */
      tiles: $( '.module-16.modulecontainer' ).find( '.tile.box' ),

      /**
       * @var   buttons The buttons
       * @since 5.6.0
       */
      buttons: $( '.tile.icon' ),

      /**
       * adjustDisplay()
       *
       * @since 5.6.0
       */
      adjustDisplay: function() {
        if( $( window )[ 0 ].innerWidth < 1280 ) {
          $( idscript.module_16.tiles ).each( function( index, element ) {
            if( !$( element ).hasClass( 'active' ) ) {
              var slide = $( element ).find( '.slide' );
              $( slide ).css( 'margin-top', '-'+$( slide )[0].scrollHeight+'px' );
              $( element ).find( '.divider' ).css({
                 marginBottom: '0px',
                 opacity: 0
              });
            }
          } );
        } else {
          $( idscript.module_16.tiles ).each( function( index, element ) {
            var slide = $( element ).find( '.slide' );
            $( slide ).css( 'margin-top', '0px' );
            $( element ).find( '.divider' ).css({
               marginBottom: '1.125rem',
               opacity: 1
            });
          } );
        }

        return;
      },

      /**
       * slide()
       *
       * @since 5.6.0
       */
      slide: function( action, tile ) {
        switch( action ) {
          case 'open':
            $( '.tile.box.tile-'+tile+' .slide' ).animate( {
              marginTop: '0px'
            }, 500 );
            $( '.tile.box.tile-'+tile+' .divider' ).animate( {
              opacity: '1',
              marginBottom: '1.125rem'
            }, 500 );
            break;
          case 'close':
            $( '.tile.box.tile-'+tile+' .slide' ).animate( {
              marginTop: '-' + $( '.tile.box.tile-'+tile+' .slide' )[ 0 ].scrollHeight + 'px'
            }, 500 );
            $( '.tile.box.tile-'+tile+' .divider' ).animate( {
              opacity: '0',
              marginBottom: '0px'
            }, 500 );
          break;
        }
      },

      /**
       * clickHandler()
       *
       * @since 5.6.0
       */
      clickHandler: function( e ) {
        //cross-browser capture of event-Object
        event = ( event ) ? event : window.event;
        event.preventDefault();

        if( $( e.currentTarget ).hasClass( 'open' ) ) {
          $( e.currentTarget ).removeClass( 'open' ).addClass( 'closed' );
          $( e.currentTarget ).parents( '.tile.box' ).removeClass( 'active' );
          idscript.module_16.slide( 'close', $( e.currentTarget ).parents( '.tile.box' )[0].dataset.tile );
        } else {
          $( e.currentTarget ).removeClass( 'closed' ).addClass( 'open' );
          $( e.currentTarget ).parents( '.tile.box' ).addClass( 'active' );
          idscript.module_16.slide( 'open', $( e.currentTarget ).parents( '.tile.box' )[0].dataset.tile );
        }

        return false;
      },

      /**
       * init()
       *
       * @since 5.6.0
       */
      init: function() {
        //organize the display
        idscript.module_16.adjustDisplay();
        $( window ).on( 'resize', idscript.module_16.adjustDisplay );
        //set click-event
        $( idscript.module_16.buttons ).each( function( index, element ) {
          $( element ).on( 'click', idscript.module_16.clickHandler );
        } );
        return;
      }
    };
    idscript.module_16.init();
  }
});
